import { isEqual } from "lodash"; // Cache only 1 value per request

var cache = new Map();
export var retrieve = function retrieve(_ref) {
  var request = _ref.request,
      using = _ref.using;
  var fromCache = cache.get(request);
  return fromCache && isEqual(fromCache.using, using) ? fromCache : undefined;
};
export var store = function store(_ref2) {
  var promise = _ref2.promise,
      request = _ref2.request,
      using = _ref2.using;
  cache.set(request, {
    using: using,
    promise: promise
  });
  promise.then(function (result) {
    var fromCache = cache.get(request);

    if (fromCache.promise === promise) {
      cache.set(request, {
        using: using,
        promise: promise,
        result: result
      });
    }
  }).catch(function (error) {
    var fromCache = cache.get(request);

    if (fromCache.promise === promise) {
      cache.set(request, {
        using: using,
        promise: promise,
        error: error
      });
    }
  });
};
export default {
  retrieve: retrieve,
  store: store
};